var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-error',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Formulaire déjà soumis")]},proxy:true}])},[_c('h1',[_vm._v("Ce formulaire est déjà soumis")]),_c('p',[_vm._v("Aucune modification n'est permise lorsque le formulaire est soumis à l'Ordre.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }